import React from 'react';

const ConstructionRealEstate = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Construction and Real Estate
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures provides comprehensive construction and real estate services, from property development and construction management to investment advisory and asset management.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Our Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Property Development</h3>
                <p className="text-gray-700">
                  End-to-end property development services for residential, commercial, and mixed-use properties, ensuring quality execution and timely delivery.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Construction Management</h3>
                <p className="text-gray-700">
                  Professional construction management services ensuring project success through expert planning, execution, quality control, and cost management.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Real Estate Investment</h3>
                <p className="text-gray-700">
                  Strategic real estate investment advisory helping clients identify prime assets with strong appreciation potential and optimal returns.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Asset Management</h3>
                <p className="text-gray-700">
                  Comprehensive asset management for real estate portfolios, optimizing performance, managing tenancies, and implementing value enhancement strategies.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Build Your Real Estate Portfolio</h3>
              <p className="mb-6">
                Discover premium construction and real estate opportunities with Vajreya Ventures.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Explore Projects
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstructionRealEstate;